<template>
  <div class="idc-billing">
  </div>
</template>
<script>
  import _ from 'lodash'
  import * as helper from '@/helper'
  import billingServices from '@/services/billing'
  export default {
    components: {},
    data () {
      return {
        params: null,
        amount: '',
        paymentMethod: '',
        currencyCode: ''
      }
    },
    watch: {
      'params' (value) {
        if (value) {
          this.handleTopup(value)
        }
      }
    },
    methods: {
      setMetaTitle () {
        helper.setMetaTitle()
      },
      getParamsRouter () {
        this.params = _.cloneDeep(this.$router.history.current.fullPath.replace('/billing/payment?', ''))
      },
      handleTopup (params) {
        this.paymentMethod = _.cloneDeep(this.$router.history.current.query.payment_method)
        if (this.paymentMethod === 'paypal') {
          billingServices.topup(params)
            .then(res => {
              this.$router.push({
                name: 'billing.success',
                query: {
                  payment_method: res.payment.payer.payment_method,
                  price: res.payment.transactions[0].amount.total,
                  currency_unit: res.payment.transactions[0].amount.currency
                }
              })
            })
            .catch(e => {
              console.log(e)
              this.$router.push({
                name: 'billing.failure'
              })
            })
        } else {
          let amount = _.cloneDeep(this.$router.history.current.query.vpc_Amount)
          this.amount = amount.substring(0, amount.length - 2)
          this.currencyCode = _.cloneDeep(this.$router.history.current.query.vpc_CurrencyCode)
          const txnResponseCode = _.cloneDeep(this.$router.history.current.query.vpc_TxnResponseCode)
          if (parseInt(txnResponseCode) !== 0) {
            this.$router.push({
              name: 'billing.failure'
            })
          } else {
            billingServices.topup(params)
              .then(res => {
                this.$router.push({
                  name: 'billing.success',
                  query: {
                    payment_method: this.paymentMethod,
                    price: this.amount,
                    currency_unit: this.currencyCode
                  }
                })
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      }
    },
    mounted () {
      this.setMetaTitle()
      this.getParamsRouter()
    }
  }
</script>
<style scoped>
  body {
    background: #001529;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/views/idc/billing/payment.vue